import React, { Component } from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import { func, bool, shape } from "prop-types";

import { actions as recoveryPasswordActions } from "reducers/recoveryPassword";

import Box from "pages/_components/Box";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import MaskedTextField from "pages/_components/fields/MaskedTextField";
import { Mixpanel } from "util/clickstreaming";
import Logo from "pages/login/_components/Logo";
import * as maskUtils from "util/mask";
import * as i18nUtils from "util/i18n";

const FORM_ID = "recoveryPassword.step2";

const recoveryI18n = {
    password: "recoveryPassword",
    username: "recoveryUsername",
};

const recoveryText = {
    password: "contraseña",
    username: "usuario",
};

class Step2Content extends Component {
    handleResendEmail = () => {
        const { dispatch } = this.props;
        const recoveryType = this.props?.match?.params?.recoveryType;

        dispatch(recoveryPasswordActions.backToStep1(recoveryType));
    };

    render() {
        const { isSubmitting, fetching, isDesktop } = this.props;
        const recoveryType = this.props?.match?.params?.recoveryType;

        return (
            <>
                {isDesktop && (
                    <div className="text-center">
                        <Logo className="svg-image logo" />
                    </div>
                )}
                <h1 className="text-center">
                    <I18n
                        id={`${recoveryI18n[recoveryType]}.step1.header`}
                        defaultValue={`Recuperar mi ${recoveryText[recoveryType]}?`}
                    />
                </h1>
                <Form className="above-the-fold login-desktop-wrapper">
                    <Container className="flex-grow items-center container--layout">
                        <Box className="mb-8">
                            <I18n id={`${recoveryI18n[recoveryType]}.step2.mailSent.message`} />
                        </Box>

                        <Field
                            autoComplete="off"
                            component={MaskedTextField}
                            mask={maskUtils.invitationCodeMask()}
                            labelTextDefault={i18nUtils.get("recoveryPassword.step2.resetCode.label")}
                            name="resetCode"
                            idForm={FORM_ID}
                            maxLength={14}
                        />

                        <Button type="submit" loading={isSubmitting} label="global.continue" bsStyle="primary" className="mb-10" />
                        
                        <Box display="flex" alignX="center" className="mb-8">
                            <I18n component="h3" id="recoveryPassword.step2.resendMail.receivedQuestion" />
                        </Box>

                        <Button
                            loading={fetching}
                            label="recoveryPassword.step2.resendMail.link"
                            className="btn-outline mb-10"
                            onClick={this.handleResendEmail}
                        />
                
                    </Container>
                </Form>
            </>
        );
    }
}

Step2Content.propTypes = {
    isSubmitting: bool,
    dispatch: func.isRequired,
    fetching: bool,
    match: !shape({}).isRequired,
    isDesktop: bool,
};

Step2Content.defaultProps = {
    isSubmitting: false,
    fetching: false,
    match: {},
    isDesktop: false,
};

export default withFormik({
    validateOnChange: false,
    validateOnBlur: false,
    mapPropsToValues: () => ({ resetCode: "" }),
    validationSchema: () =>
        Yup.object().shape({
            resetCode: Yup.string().required(i18nUtils.get(`${FORM_ID}.resetCode.required`)),
        }),
    handleSubmit: (values, formikBag) => {
        Mixpanel.track(FORM_ID);
        formikBag.props.dispatch(recoveryPasswordActions.recoveryPassStep2(values.resetCode, formikBag));
    },
})(Step2Content);
